let lenisInstance = null;

export const setLenis = (l) => {
  lenisInstance = l;
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenisInstance) {
    lenisInstance.scrollTo(el, { offset: -88, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const selectLotForInquiry = (lotName) => {
  window.dispatchEvent(new CustomEvent("select-lot", { detail: lotName }));
  scrollToId("inquiry-form");
};
